var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSalioGeocerca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#870000;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-salio-geocerca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_28",
    "data-name": 28
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.71,167q20.6-16.69,41.29-33.25c1-.77,1.88-1.58,2.79-2.35-4.41-2.58-8.84-1.84-13.29-1.15-2.54.4-13.59,1.58-13.59,1.58l0-2.79s15.44-1.7,18.49-2.14a3.72,3.72,0,0,1,2.79-3.81,33.67,33.67,0,0,1,6.86-1.93,31.9,31.9,0,0,1,15.16,1c1.86.64,3.44,2.07,5.15,3.15v1.59c-2.43,3.27-6.15,3.71-9.73,4.29-2.08.34-4.25.16-6.35.41a5.65,5.65,0,0,0-3,1.13Q156,150.76,136.87,168.92c-.28.27-.54.57-1,1.05.71.49,1.35.9,2,1.34,2.79,1.94,2.94,4.53-.06,6.11a31.41,31.41,0,0,1-8.56,3,41.93,41.93,0,0,1-19.72-.84,20.13,20.13,0,0,1-3.34-1.27c-3.77-1.88-4.21-3.6-1.78-7.06-.56-.34-1.1-.7-1.66-1C89.15,162.83,75.57,155.42,62,148.1a5.79,5.79,0,0,0-3.34-.52c-6,.84-12.09,1.08-17.95-.84-2.09-.68-3.88-2.32-5.81-3.52v-2c3.94-3.92,9.07-4.39,14.16-4.68,5.47-.3,10.88.2,15.92,2.71a3.41,3.41,0,0,0,1.72.1c8.91-1,29.17-3.32,29.17-3.32l.07,2.43S76.22,140.86,69,141.68a2.26,2.26,0,0,0-2,1.49c-.67,1.26-2.06,2.13-3.26,3.27a13.6,13.6,0,0,0,1.32.74c14.62,6.64,29.28,13.18,43.83,20C111.93,168.57,127.45,168,128.71,167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.48,53.88l27,27.85H135.87v61.13H105.1V81.73H93.5l27-27.85m0-9.61L77.71,88.42h20.7v61.13h44.14V88.42h20.7L120.48,44.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSalioGeocerca);
export default __webpack_public_path__ + "static/media/ic-salio-geocerca.dc23bdaeadb31748a1e219245c17e2d1.svg";
export { ForwardRef as ReactComponent };